import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section className="relative py-16 md:py-24 lg:py-32 overflow-hidden" data-id="element-26">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-white to-sky-50" data-id="element-27" />
      <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-indigo-200/30 rounded-full blur-3xl" data-id="element-28" />
      <div className="absolute bottom-0 left-0 w-64 h-64 md:w-96 md:h-96 bg-sky-200/30 rounded-full blur-3xl" data-id="element-29" />
      <div className="relative max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-31">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-4 md:mb-6 px-4" data-id="element-32">
            Ready to Transform Your Business Communications?
          </h2>
          <p className="text-base md:text-xl text-gray-600 mb-8 md:mb-10 max-w-2xl mx-auto px-4" data-id="element-33">
            Join hundreds of Australian businesses using WellAd to never miss a
            call or opportunity again.
          </p>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => window.location.href = 'https://wellad.online/index.php/ai-voice-agent-onboarding/'} className="px-8 py-3 md:px-10 md:py-4 text-sm md:text-lg bg-black text-white rounded-full font-semibold hover:shadow-2xl transition-all" data-id="element-34">
            Start Your Free Trial Today
          </motion.button>
        </motion.div>
      </div>
    </section>;
}